import { request } from "./request";

export function addDoctor(data) {
  return request("/hospital/addDoctor", {
    method: "POST",
    body: {
      hospitalId: String(data.hospitalId),
      doctorName: String(data.doctorName ?? "").trim(),
      phone: String(data.phone ?? "").trim(),
    },
  });
}


export function listDoctors(data) {
  return request("/hospital/listDoctors", {
    method: "POST",
    body: {
      hospitalId: String(data.hospitalId),
    },
  });
}

export function updateDoctor(data) {
  return request("/hospital/updateDoctor", {
    method: "POST",
    body: {
      doctorId: String(data.doctorId),
      realName: String(data.realName ?? "").trim(),
      phone: String(data.phone ?? "").trim(),
    },
  });
}

export function listAllDoctors(data) {
  return request("/doctor/listAllDoctors", {
    method: "POST",
    body: {
      pageNum: Number(data.pageNum) || 1,
      pageSize: Number(data.pageSize) || 10,
      realName: String(data.realName ?? "").trim(),
      phone: String(data.phone ?? "").trim(),
    },
  });
}

export function listRelatedHospitals(data) {
  return request("/doctor/listRelatedHospitals", {
    method: "POST",
    body: {
      doctorId: String(data.doctorId),
    },
  });
}

export function relateDoctorHospital(data) {
  return request("/doctor/relateHospital", {
    method: "POST",
    body: {
      doctorId: String(data.doctorId),
      hospitalIds: (data.hospitalIds || []).map((id) => String(id)),
    },
  });
}
